/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseFeedback
 */
export interface CaseFeedback {
    /**
     * 
     * @type {string}
     * @memberof CaseFeedback
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedback
     */
    feedbackType?: CaseFeedbackFeedbackTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedback
     */
    rating?: CaseFeedbackRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedback
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedback
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseFeedback
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseFeedback
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaseFeedback
     */
    tenantId?: string;
    /**
     * 
     * @type {any}
     * @memberof CaseFeedback
     */
    securityCase?: any | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseFeedback
     */
    metadata?: { [key: string]: any; };
}


/**
 * @export
 */
export const CaseFeedbackFeedbackTypeEnum = {
    Comment: 'COMMENT',
    Analysis: 'ANALYSIS',
    Resolution: 'RESOLUTION',
    Escalation: 'ESCALATION',
    Feedback: 'FEEDBACK'
} as const;
export type CaseFeedbackFeedbackTypeEnum = typeof CaseFeedbackFeedbackTypeEnum[keyof typeof CaseFeedbackFeedbackTypeEnum];

/**
 * @export
 */
export const CaseFeedbackRatingEnum = {
    ThumbsUp: 'THUMBS_UP',
    ThumbsDown: 'THUMBS_DOWN',
    OneStar: 'ONE_STAR',
    TwoStars: 'TWO_STARS',
    ThreeStars: 'THREE_STARS',
    FourStars: 'FOUR_STARS',
    FiveStars: 'FIVE_STARS',
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Average: 'AVERAGE',
    Poor: 'POOR',
    VeryPoor: 'VERY_POOR'
} as const;
export type CaseFeedbackRatingEnum = typeof CaseFeedbackRatingEnum[keyof typeof CaseFeedbackRatingEnum];


/**
 * Check if a given object implements the CaseFeedback interface.
 */
export function instanceOfCaseFeedback(value: object): value is CaseFeedback {
    return true;
}

export function CaseFeedbackFromJSON(json: any): CaseFeedback {
    return CaseFeedbackFromJSONTyped(json, false);
}

export function CaseFeedbackFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFeedback {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'feedbackType': json['feedbackType'] == null ? undefined : json['feedbackType'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'securityCase': json['securityCase'] == null ? undefined : json['securityCase'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function CaseFeedbackToJSON(json: any): CaseFeedback {
    return CaseFeedbackToJSONTyped(json, false);
}

export function CaseFeedbackToJSONTyped(value?: CaseFeedback | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'feedbackType': value['feedbackType'],
        'rating': value['rating'],
        'comment': value['comment'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'tenantId': value['tenantId'],
        'securityCase': value['securityCase'],
        'metadata': value['metadata'],
    };
}

